import * as Yup from 'yup';
import {
  ParseError,
  parsePhoneNumber,
} from 'libphonenumber-js';

Yup.addMethod(Yup.string, 'testPhone', function testPhoneWrapper(ref, message) {
  return this.test('testPhone', message, function testPhoneInner(value) {
    const { path, createError } = this;
    const errors = {
      INVALID_COUNTRY: 'Phone number has invalid country code',
      TOO_LONG: 'Phone number is too long',
      TOO_SHORT: 'Phone number is too short',
      NOT_A_NUMBER: 'Invalid phone number',
    };
    try {
      const phone = parsePhoneNumber(value, 'US');
      // minimum valid international number length
      if (phone.formatInternational().length < 8) {
        return createError({
          path,
          message: errors?.TOO_SHORT,
        });
      }
    } catch (error) {
      if (error instanceof ParseError) {
        return createError({
          path,
          message: errors[error.message],
        });
      }
      return createError({
        path,
        message: error.message,
      });
    }
    return true;
  });
});
